import React from "react";
import { NavLink, useRouteMatch } from "polyrouter";
import { useTranslation } from "utilities/i18n";

const CategorySwitcher: React.FC<{
  className?: string;
  "data-testid"?: string;
}> = ({ className = "", children, ...rest }) => {
  return (
    <div
      className={`menu category-switcher ${className}`}
      data-testid={rest["data-testid"] ?? "switcher-test"}
    >
      <ul>{children}</ul>
    </div>
  );
};

const CategoryDiv: React.FC<{
  label: string;
  active: boolean;
  onClick?: any;
  disabled?: boolean;
  fetching?: boolean;
  "data-testid"?: string;
  divClass?: string;
}> = ({ label, active, onClick, disabled, fetching, divClass, ...rest }) => {
  const { t } = useTranslation();
  const disabledClass = disabled ? "disabled" : "";
  const divClasses = [disabledClass, divClass].join(" ").trim();
  return (
    <li className={active ? "active" : disabledClass}>
      <div
        onClick={onClick}
        data-testid={rest["data-testid"]}
        className={divClasses}
      >
        {fetching ? t("LOADING") : label}
      </div>
    </li>
  );
};

const Category: React.FC<{ to: string; exact?: boolean; label: string }> = ({
  to,
  exact = false,
  label
}) => {
  let match = useRouteMatch({
    path: to,
    exact: exact
  });
  return (
    <li className={match ? "active" : ""}>
      <NavLink to={to}>{label}</NavLink>
    </li>
  );
};

export default CategorySwitcher;
export { Category, CategoryDiv };
